const DEFAULT_VERSION = 'latest';
export const VERSION = typeof "3.1.8" !== 'undefined' ? "3.1.8" : DEFAULT_VERSION;

if (typeof "3.1.8" === 'undefined') {
  console.error('loaders.gl: The __VERSION__ variable is not injected using babel plugin. Latest unstable workers would be fetched from the CDN.');
}
//# sourceMappingURL=version.js.map